import { useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { useDetectPrint } from '~/components/hooks/useDetectPrint'
import { useFieldError } from '~/components/FormContext'

const MAX_LENGTH = 2000

export const Message = () => {
  const name = 'message'
  const isPrinting = useDetectPrint()
  const error = useFieldError(name)
  const getCharsLeft = (value: string) => {
    const safeValue = value || ''
    return MAX_LENGTH - safeValue.length
  }
  const [charsLeft, setCharsLeft] = useState(getCharsLeft(''))

  const handleChange = ({ target: { value } }: { target: { value: string } }) => {
    setCharsLeft(getCharsLeft(value))
  }

  const renderCharLeft = () => {
    let warning = ''
    if (charsLeft < 10 && charsLeft > 0) {
      warning = 'font-bold text-orange-400'
    } else if (charsLeft === 0) {
      warning = 'font-bold text-red-900'
    }

    return charsLeft >= 0 ? (
      <span className={`characters-left-text ${warning}`}>{`characters left: ${charsLeft}`}</span>
    ) : null
  }

  return (
    <div className="print-break">
      <>
        <TextareaAutosize
          maxLength={MAX_LENGTH}
          id={name}
          name={name}
          minRows={5}
          readOnly={isPrinting}
          placeholder="Write an optional message that will be presented to your family, or loved one(s)  at the time of donation/decision"
          className="form-textarea
                   mt-2
                   mb-2
                   w-full
                   rounded-md
                   border-gray-300
                   text-sm
                   placeholder-gray-400
                   focus:border-indigo-300 focus:ring-1
                   focus:ring-primary-blue
                   focus:ring-opacity-50"
          onChange={handleChange}
        />
        <div className="print:hidden">{renderCharLeft()}</div>
        {error && <p className="font-bold text-red-900">{error}</p>}
      </>
    </div>
  )
}
